import React, { useState, useEffect } from 'react'
import { useTable, useRowSelect } from 'react-table'
import { useDispatch, useSelector } from 'react-redux'
import { motion } from 'framer-motion'


import { deletedColumn } from '../deletedItems/deletedColumn'
import './deletedTable.css'
import { fetchDeletedLineItems, restoreDeletedAllLineItems, restoreDeletedLineItems } from '../../services/api/apiHandler'
import swal from 'sweetalert'
import { fetchConventionalMode, restoreLineItems, restoreMultiLineItems } from '../../redux/actions/TemplateTabs/actionCM'
import { Spinner } from 'react-bootstrap'

import commoncss from "../../myfin_v2/css/common.module.css";
import buttoncss from "../../myfin_v2/css/button.module.css";
import tablecss from "../../myfin_v2/css/table.module.css";
import bookclosurecss from "../../myfin_v2/css/bookclosure.module.css";
import Modal from "../../myfin_v2/elements/Modal";
import InputGroup from "../../myfin_v2/elements/InputGroup";
import { Button } from "../../myfin_v2/elements/Button";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as RestoreIcon } from "../../myfin_v2/assets/icons/restore.svg";
import emptyState from "../../myfin_v2/assets/icons/Empty State.png";
import RetryIcon from "../../myfin_v2/assets/icons/Retry.png";
import RestorePopup from "../../myfin_v2/elements/RestorePopup";

import Checkmark from "../../myfin_v2/assets/icons/Check(circle).png";


const screen = {
  width: '100%',
  height: '100%',
  position: 'fixed',
  zIndex: '999',
  backgroundColor: '#11111136',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',

}
const container = {
  minHeight: '75vh',
  borderRadius: '10px',
  maxHeight: '70vh',
  // overflowY:'scroll',
  minWidth: '560px',
  padding: '0',
  zIndex: '15',
  backgroundColor: 'white'
}

const header = {

  display: 'flex',
  padding: '1rem 2rem 1rem 2rem',
  justifyContent: 'space-between',
  backgroundColor: '#F1F2F5',
  borderTopLeftRadius: '10px',
  borderTopRightRadius: '10px',
  position: 'sticky',
  top: '0'


  // borderRadius:'10px',


}

const buttonDiv = {
  display: 'flex',
  alignItems: 'center'

}
const button = {
  marginLeft: 'auto'

}

const para = {
  marginTop: '0px',
  fontWeight: '400',
  fontSize: '1rem',
  color: 'var(--clr-font-mid)'
}


const DeletedFile = (props) => {
  const dispatch = useDispatch();
  const [deletedRow, setDeletedRow] = useState({
    loading: false,
    isSuccess: false,
    response: [],
    error_message: ''
  })
  const [change, setChange] = useState(0)
  const [delRows, setDelRows] = useState([])
  const tb_id = useSelector(initialState => initialState.reducer.tb_id)
  const project_id = localStorage.getItem('project_id');
  const user = JSON.parse(localStorage.getItem('user'));
  const [showRestoreConfirm, setShowRestoreConfirm] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [restoreConfirmData, setRestoreConfirmData] = useState(null);

  useEffect(() => {
    setDeletedRow({
      ...deletedRow,
      loading: true,
    })
    fetchDeletedLineItems(project_id, tb_id).then((response) => {
      setDeletedRow({
        ...deletedRow,
        isSuccess: true,
        loading: false,
        response: response.data.deleted_items
      })
      setDelRows(response.data.deleted_items.map((row) => row.item));
    }).catch((err) => {
      console.log("err", err)
      setDeletedRow({
        ...deletedRow,
        isSuccess: false,
        loading: false,
        error_message: err.message
      })
    })
  }, [change])

  const handleRestore = (row) => {
    if (user.responsibilities === "approver" || user.responsibilities === "view") {
      swal("Warning", "You Don't have access to restore", "warning");
      return;
    }

    setRestoreConfirmData(row);
  }

  function handleClose() {
    props.setDeleteMenu(false)
  }

  const IndeterminateCheckbox = React.forwardRef(
    ({ indeterminate, ...rest }, ref) => {
      const defaultRef = React.useRef()
      const resolvedRef = ref || defaultRef

      React.useEffect(() => {
        resolvedRef.current.indeterminate = indeterminate
      }, [resolvedRef, indeterminate])

      return (
        <>
          <input type="checkbox" ref={resolvedRef} {...rest} />
        </>
      )
    }
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    state: { selectedRowIds },
  } = useTable({
    columns: deletedColumn,
    // data: TABLE_MOCK
    data: delRows
    // data: deleted_file
  },
    useRowSelect,
    hooks => {
      hooks.visibleColumns.push(columns => [
        // Let's make a column for selection
        {
          id: 'selection',
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ])
    }
  )

  const RestoreSelected = () => {
    const data = { deletedLineItems: selectedFlatRows.map(ele => ele.original) }

    restoreDeletedAllLineItems(project_id, tb_id, data).then(response => {
      dispatch(fetchConventionalMode(project_id, tb_id));
      dispatch(restoreMultiLineItems(project_id, tb_id));
      const newResultSet = deletedRow.response.filter(item => !selectedFlatRows.some(item2 => item2.original.lid === item.item.lid));
      setDeletedRow({
        ...deletedRow,
        response: newResultSet
      });
      setDelRows(newResultSet.map((row) => row.item));

      setShowSuccessPopup(true);

       setTimeout(() => {
        setShowSuccessPopup(false);
        handleClose(); 
      }, 2000);
    }).catch(error => {
      handleClose();
      swal("Error", error.response?.data?.error || "Items Restore Failed!", "error");
    })
  }

  const formatIndianNumber = (val) => {
    if (val === null || val === undefined || isNaN(val) || val === '') return val;
    const num = Number(val);
    const formatted = Math.abs(num).toLocaleString('en-IN', { maximumFractionDigits: 2 });
    return num < 0 ? `(${formatted})` : formatted;
  };

  if (showSuccessPopup) {
    return (
      <div className={commoncss.overlay}>
        <div className={commoncss.popup} style={{ width: "380px", height: "245px"}}>
          <div className={commoncss.iconWrapper} >
            <img src={Checkmark} alt="Success" width={90} height={90} />
          </div>
          <p className={commoncss.restoreText}>Restored Successfully</p>
        </div>
      </div>
    );
  }

  return (
    <>
    <Modal
      title="Restore Deleted Items"
      width={rows.length > 0 ? "50%" : "30%"}
      bodycss={commoncss.unsetPadding}
      headerActions={
        <div>
        <span style={{ color: "#2d8861", fontWeight: 500, marginRight: "20px", cursor: "default"}}
         onClick={() => setShowRestoreConfirm(true)}
        >
          Restore All
        </span>
        <CloseIcon
          onClick={handleClose}
          className="clickable"
        />
        </div>
      }
      onClose={() => console.log("Modal Closed")}
      footerActions={
        <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between' }}>
          <Button
            btnColor={buttoncss.secondary}
            onClick={handleClose}
            label="Cancel"
          />
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {
              selectedFlatRows && selectedFlatRows?.length > 0 ? (
                <>
                  <span className={`${commoncss.primaryLabel1} ${commoncss.fs15} ${commoncss.fw600} mr-3`}>({selectedFlatRows?.length}) SELECTED</span>
                  <Button
                    btnColor={buttoncss.primary}
                    label={"Restore Selected"}
                    onClick={() => RestoreSelected()}
                  />
                </>
              ) : (
                <Button
                  btnColor={buttoncss.primary}
                  label={"Restore Selected"}
                  class_={buttoncss.disabledBtn}
                />
              )
            }
            {/*
            {rows.length > 0 ?(<></>): (
            <Button
              btnColor={buttoncss.primary}
              onClick={handleClose}
              label="Proceed"
            />)}
            */}
          </div>
        </div>
      }
    >
      <div style={{ minHeight: "200px" }}>
        {rows.length > 0 ? (
         <div  style={{ padding: "0 0 24px" }}>
          <table className={tablecss.customTable} {...getTableProps()} style={{ width: "100%" }}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => {
                    const headerText = column.render("Header");
                    const isSelection = column.id === 'selection';
                    const isAction = headerText === "ACTION";
                    
                    if (isSelection) {
                      return (
                        <th className='text-left font-inter' style={{ paddingLeft: "27px", width: "40px" }} {...column.getHeaderProps()}>
                          {headerText}
                        </th>
                      );
                    } else if (isAction) {
                      return (
                        <th className='text-right font-inter' style={{ paddingRight: "27px", width: "40px" }} {...column.getHeaderProps()}>
                          
                        </th>
                      );
                    } else if ((headerText === "Current YEAR") || (headerText === "PREVIOUS YEAR")) {
                      return (
                        <th className='text-right pl-2 font-inter' {...column.getHeaderProps()}>
                          {headerText}
                        </th>
                      );
                    } else if (headerText === "LEDGER CODE" ||  headerText === "LEDGER NAME") {
                      return (
                        <th className='text-left pl-2 font-inter' {...column.getHeaderProps()}>
                          {headerText}
                        </th>
                      );
                    } else {
                      return (
                        <th className='text-center pl-2 font-inter' {...column.getHeaderProps()}>
                          {headerText}
                        </th>
                      );
                    }
                  })}
                </tr>
              ))}
            </thead>

            <tbody {...getTableBodyProps()}>
              {rows.map((row, i) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell, i) => {
                      const headerText = cell.column.Header;
                      const isSelection = cell.column.id === 'selection';
                      const isAction = headerText === "ACTION";

                      if (isSelection) {
                        return (
                          <td className='text-left' style={{ paddingLeft: "27px" }} {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        );
                      } else if (isAction) {
                        return (
                          <td className='text-right' style={{ paddingRight: "27px" }} {...cell.getCellProps()}>
                            <RestoreIcon width={18} height={18} className={commoncss.clickable} onClick={() => {
                              handleRestore(row.original);
                            }} />
                          </td>
                        );
                      } else if ((headerText === "Current YEAR") || (headerText === "PREVIOUS YEAR")) {
                        return (
                          <td className='text-right pl-2' {...cell.getCellProps()}>
                            {formatIndianNumber(cell.value)}
                          </td>
                        );
                      } else if (headerText === "LEDGER CODE" || headerText === "LEDGER NAME") {
                        return (
                          <td className='text-left pl-2' {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        );
                      } else {
                        return (
                          <td className='text-center pl-2' {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        );
                      }

                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        ) : (
          <>
            <div className={`${commoncss.dFlexClm} mt-5`} style={{"align-items":"center"}}>
              <img src={emptyState} alt="Empty State" width="240"height="100" />
              <span style={{ fontSize: '18px', fontWeight: '600', color: '#1A493B', marginTop: '16px' }}>Nothing here yet</span>
              <span className={`${commoncss.greyLabel} mt-2`}>There are no deleted items</span>
            </div>
          </>
        )}

      </div>
      {showRestoreConfirm && (
        <div className={commoncss.overlay}>
          <div className={commoncss.confirmPopup}>
            <div className={commoncss.confirmHeader}>
              <span
                className={commoncss.closeIcon}
                onClick={() => setShowRestoreConfirm(false)}
              >
                <CloseIcon/>
              </span>
            </div>
            <p className={commoncss.confirmTitle}>
              Do you want to <b>restore </b> all <strong>{selectedFlatRows.length}</strong> items?
            </p>

            <p className={commoncss.confirmSubText}>
             This action will restore all selected items to the active list
            </p>

            <div className={commoncss.confirmActions}>
              <button
                className={commoncss.confirmBtn}
                onClick={() => {
                  setShowRestoreConfirm(false);
                  RestoreSelected(); 
                }}
              >
                <img src={RetryIcon} alt="restore" style={{ marginRight: "6px" }}/>
                Yes, Restore
              </button>
              <button
                className={commoncss.cancelBtn}
                onClick={() => setShowRestoreConfirm(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

    </Modal>
    <RestorePopup
      isOpen={restoreConfirmData !== null}
      title={<>Do you want to <span style={{ fontWeight: 700 }}>restore</span> this item?</>}
      message="This will restore the item from the bin"
      onConfirm={() => {
        if (!restoreConfirmData) return;
        const row = restoreConfirmData;
        setRestoreConfirmData(null);
        
        restoreDeletedLineItems(project_id, row).then((response) => {
          dispatch(fetchConventionalMode(project_id, tb_id));
          dispatch(restoreLineItems(row, project_id, tb_id));
          const newResultSet = deletedRow.response.filter(item => item.item.lid !== row.lid);
          setDeletedRow({
            ...deletedRow,
            response: newResultSet
          });
          setDelRows(newResultSet.map((r) => r.item));
          swal("Success", "Restored successfully", "success");
        }).catch((err) => {
          console.log("err", err.message)
          handleClose();
          swal("Something went wrong", {
            icon: "error"
          })
        });
      }}
      onCancel={() => setRestoreConfirmData(null)}
    />
    </>
  );
}

export default DeletedFile
